import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const BaseElevatedCard = ({ baseClassName, className, children, ...props }) => {
    const classes = classNames(baseClassName, className);

    return (
        <div className={classes} {...props}>
            {children}
        </div>
    );
};

BaseElevatedCard.propTypes = {
    className: PropTypes.string,
    baseClassName: PropTypes.string,
};

BaseElevatedCard.defaultProps = {
    className: "",
    baseClassName: "elevation-two",
};

const MemoElevatedCard = React.memo(BaseElevatedCard);

export const CardLevelZero = (props) => (
    <MemoElevatedCard baseClassName="elevation-zero" {...props} />
);
export const CardLevelOne = (props) => (
    <MemoElevatedCard baseClassName="elevation-one" {...props} />
);
export const CardLevelTwo = (props) => (
    <MemoElevatedCard baseClassName="elevation-two" {...props} />
);
export const CardLevelThree = (props) => (
    <MemoElevatedCard baseClassName="elevation-three" {...props} />
);
export const CardLevelFour = (props) => (
    <MemoElevatedCard baseClassName="elevation-four" {...props} />
);
